import React from 'react';
import Typography from '@mui/material/Typography';

const CustomHeader = ({ value }) => {
    return (
        <Typography variant="h2" color="text.secondary" sx={{fontWeight: 'bold', fontSize: '4.0rem', lineHeight: 1, paddingTop: 1, margin: 'auto', marginBottom: '25px'}} gutterBottom>
            {value}
        </Typography>
    );
};

export default CustomHeader;